import { AdminHeader } from '../AdminHeader';
import { useAdminChecker } from '../../hooks/useAdminChecker';
import { Outlet } from 'react-router-dom';
import { Loader } from '../../../common/shared/Loader';
import styles from './styles.module.scss';

export const AdminLayout = () => {
  const { authenticated, loading } = useAdminChecker();
  return (
    <>
      <Loader visible={loading} />
      {!loading && (
        <>
          {authenticated && <AdminHeader />}
          <main className={styles.main}>
            <Outlet />
          </main>
        </>
      )}
    </>
  );
};
